<template >
  <div class="quality-inspection-standard">
    <Form
      class="form-inspection-standard"
      ref="formRef"
      :model="formData"
      :label-width="110"
      label-position="right"
      :inline="true"
    >
      <Form-item label="质检模板：">
        <dyt-select v-model="formData.qualityTemplateId" :transfer="false" :disabled="disabled" placeholder="请选择质检模板">
          <Option
            v-for="(option, index) in qualityTemplateList"
            :value='option.qualityClassificationId'
            :key="`quality-${index}`"
            :label="option.qualityClassification"
            @click.native="selectClickOption"
          />
        </dyt-select>
      </Form-item>
      <div>
        <Button v-if="!disabled" type="primary" @click="addQualityObject" :disabled="loading">新增质检项目</Button>
        <Table
          class="mt10 quality-edit-table"
          highlight-row
          border
          :columns="tableColumns"
          :data="tableData"
        >
          <template slot-scope="{ index, row }" slot="operate">
            <Button type="error" size="small" @click="removeTableRow(row, index)" :disabled="loading || disabled">删除</Button>
          </template>
          <template slot-scope="{ index, row }" slot="qualityProject">
            <Form-item
              label=""
              :label-width="0"
              :class="{'ivu-form-item-error': errTips[index] && errTips[index].qualityProject}"
            >
              <Input
                v-model="tableData[index].qualityProject"
                placeholder="请输入质检项目"
                :disabled="disabled"
                @input="inputValChange(tableData[index].qualityProject, index, 'qualityProject')"
                @on-blur="inputValChange(tableData[index].qualityProject, index, 'qualityProject')"
              />
            </Form-item>
          </template>
          <template slot-scope="{ index, row }" slot="qualityDescription">
            <Form-item
              label=""
              :label-width="0"
              :class="{'ivu-form-item-error': errTips[index] && errTips[index].qualityDescription}"
            >
              <Input
                v-model="tableData[index].qualityDescription"
                placeholder="请输入质检内容描述"
                :disabled="disabled"
                @input="inputValChange(tableData[index].qualityDescription, index, 'qualityDescription')"
                @on-blur="inputValChange(tableData[index].qualityDescription, index, 'qualityDescription')"
              />
            </Form-item>
          </template>
          <template slot-scope="{ index, row }" slot="qualityPrice">
            <Form-item
              label=""
              :label-width="0"
              :class="{'ivu-form-item-error': errTips[index] && errTips[index].price}"
            >
              <Input
                v-model="tableData[index].price"
                placeholder="请输入价格"
                :disabled="disabled"
                @input="inputValChange(tableData[index].price, index, 'price')"
                @on-blur="inputValChange(tableData[index].price, index, 'price')"
              />
            </Form-item>
          </template>
        </Table>
      </div>
    </Form>
    <div style="padding: 15px 20px 0 0; text-align: right;">质检价格合计：{{ editModalTotal.toFixed(2) }}</div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'qualityInspectionStandard',
  props: {
    disabled: { type: Boolean, default: false },
    productInfo: { type: Object, default: () => { return {} } },
    productId: { type: String, default: '' },
    editProductModal: { type: Boolean, default: false },
    productCategoryListData: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      loading: false,
      newQualityType: false,
      formData: {
        qualityTemplateId: '',
      },
      tableData: [],
      oldData: [],
      errTips: [],
      qualityTemplateList: [],
      qualityTemplateJson: {},
      tableColumns: [
        {
          title: '操作',
          slot: 'operate',
          width: 90,
          align: 'center',
        },
        {
          title: '质检项目',
          slot: 'qualityProject',
          width: 150,
          align: 'left',
        },
        {
          title: '质检内容描述',
          slot: 'qualityDescription',
          minWidth: 200,
          align: 'left',
        },
        {
          title: '价格',
          slot: 'qualityPrice',
          width: 120,
        }
      ],
      tableValidate: {
        qualityProject: { validator: this.formRequiredVerify, msg: '请输入质检项目' },
        qualityDescription: { validator: this.formRequiredVerify, msg: '请输入质检内容描述' },
        price: { validator: this.validatorPrice, msg: '请输入价格' },
      },
    }
  },
  computed: {
    tempQualityClassificationId () {
      return !this.$common.isEmpty(this.productInfo) ? this.productInfo.tempQualityClassificationId : ''
    },
    // 选中的列表
    qualityProjectVOList () {
      let newTemplateData = [];
      let newType = false;
      if (!this.$common.isEmpty(this.productInfo) && !this.$common.isEmpty(this.productInfo.productCustomQualityProjects)) {
        newTemplateData = this.productInfo.productCustomQualityProjects;
        newType = true;
      } else {
        newTemplateData = this.qualityTemplateJson[this.formData.qualityTemplateId || this.tempQualityClassificationId] || [];
      }
      return { data: newTemplateData, newType: newType };
    },
    isUseNewType () {
      let oldTxt = '';
      let newTxt = '';
      (this.oldData || []).forEach(row => {
        oldTxt = `${oldTxt}${row.qualityProject || ''}${row.qualityDescription || ''}${row.price || ''}`;
      });
      (this.tableData || []).forEach(row => {
        newTxt = `${newTxt}${row.qualityProject || ''}${row.qualityDescription || ''}${row.price || ''}`;
      });
      let saveType = oldTxt !== newTxt || this.oldData.length != this.tableData.length;
      return saveType;
    },
    // 合计
    editModalTotal () {
      if (this.$common.isEmpty(this.tableData)) return 0;
      let priceTotal = 0;
      let newPrice = null;
      this.tableData.forEach(row => {
        newPrice = Number(row.price);
        if (!(this.$common.isEmpty(newPrice) || newPrice < 0)) {
          priceTotal += newPrice;
        }
      });
      return priceTotal;
    }
  },
  watch: {
    editProductModal: {
      immediate: true,
      deep: true,
      handler (val) {
        if (!val) {
          this.loading = false;
          this.formData = {
            qualityTemplateId: '',
            tableData: [],
          }
          return;
        }
        this.$nextTick(() => {
          this.initData();
        })
      }
    },
    qualityProjectVOList: {
      immediate: true,
      deep: true,
      handler (val) {
        this.oldData = [];
        this.tableData = this.$common.copy(val.data || []);
        if (!val.newType) {
          this.oldData = this.$common.copy(val.data || []);
        }
        this.errTips = this.tableData.map(m => {
          return {
            qualityProject: false,
            qualityDescription: false,
            price: false,
          }
        });
      }
    },
    // 是否使用新方式
    isUseNewType (val) {
      setTimeout(() => {
        this.newQualityType = val;
      }, 300)
    },
  },
  created () {},
  methods: {
    initData () {
      this.loading = true;
      let getData = [];
      // 获取所有质检模板信息
      getData.push(() => {
        return this.getAllQualityData
      });
      this.$common.promiseAll(getData).then((res) => {
        this.formData = {
          qualityTemplateId: this.productInfo.qualityClassificationId
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    // 返回当前选中的项目模板ID
    getFormData () {
      if (this.newQualityType) {
        return {
          data: {
            productCustomQualityProjectList: this.tableData.map((item) => {
              return {
                qualityProject: item.qualityProject,
                qualityDescription: item.qualityDescription,
                price: item.price,
              }
            }),
            productIdList: [this.productId],
            selectAll: 0,
          },
          newType: this.newQualityType
        }
      }
      // 当里面的内容不一致时，使用另外的一个接口保存
      if (this.tempQualityClassificationId === this.formData.qualityTemplateId && this.$common.isEmpty(this.productInfo.qualityClassificationId)) {
        return { data: '', newType: this.newQualityType }
      }
      return { data: this.formData.qualityTemplateId, newType: this.newQualityType }
    },
    // 质检模板改变时
    selectClickOption () {
      this.$nextTick(() => {
        const newTemplateData = this.qualityTemplateJson[this.formData.qualityTemplateId || this.tempQualityClassificationId] || [];
        this.oldData = this.$common.copy(newTemplateData);
        this.tableData = this.$common.copy(newTemplateData);
        this.errTips = this.tableData.map(m => {
          return {
            qualityProject: false,
            qualityDescription: false,
            price: false,
          }
        });
      });
    },
    // 新增质检项目
    addQualityObject () {
      this.tableData.push({
        qualityProject: '',
        qualityDescription: '',
        price: '',
      });
      this.errTips.push({
        qualityProject: false,
        qualityDescription: false,
        price: false,
      });
    },
    // 移除列表行
    removeTableRow (row, index) {
      if (this.$common.isEmpty(row.qualityProject)) {
        this.tableData.splice(index, 1);
        this.errTips.splice(index, 1);
        return;
      }
      this.$Modal.confirm({
        title: '操作提示',
        content: `确认删除质检项目：<span style="color:#f20;">${row.qualityProject}</span>`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.tableData.splice(index, 1);
          this.errTips.splice(index, 1);
        }
      })
    },
    // 验证
    validate (backFun) {
      (this.tableData || []).forEach((row, index) => {
        Object.keys(this.tableValidate).forEach(key => {
          this.inputValChange(row[key], index, key);
        });
      });
      this.$nextTick(() => {
        if (backFun) {
          setTimeout(() => {
            const allErrItem = document.querySelectorAll('.form-inspection-standard .ivu-form-item-error');
            if (allErrItem.length > 0) {
              backFun(false);
              const inputDemo = allErrItem[0].querySelector('input');
              inputDemo && inputDemo.focus();
            } else {
              backFun(true);
            }
          }, 300)
        }
      });
    },
    // 输入框值改变
    inputValChange (val, index, key) {
      if (this.$common.isEmpty(this.tableValidate[key])) return;
      const vItem = this.tableValidate[key];
      vItem.validator(vItem.msg, val, index, key, false);
    },
    // 必填验证
    formRequiredVerify (msg, val, index, key, type = false) {
      this.errTips[index][key] = this.$common.isEmpty(val);
      type && this.$Message.error(msg);
    },
    // 价格验证
    validatorPrice (msg, val, index, key, type = false) {
      if (this.$common.isEmpty(val)) {
        this.errTips[index][key] = true;
        type && this.$Message.error(msg);
        return;
      }
      const newVal = Number(val);
      const decimals = (val.toString()).split('.');
      if (this.$common.isEmpty(newVal) || (decimals.length > 1 && this.$common.isEmpty(decimals[0]))) {
        this.errTips[index][key] = true;
        type && this.$Message.error('请输入数字');
        return;
      }
      if (newVal < 0) {
        this.errTips[index][key] = true;
        type && this.$Message.error('请输入大于 0 且最多2位小数的数字');
        return;
      }
      if (!this.$common.isEmpty(decimals[1]) && decimals[1].length > 2) {
        this.errTips[index][key] = true;
        type && this.$Message.error('请输入大于 0 且最多2位小数的数字');
        return;
      }
      this.errTips[index][key] = false;
    },
    // 获取所有质检模板
    getAllQualityData () {
      return new Promise((resolve) => {
        this.qualityTemplateJson = {};
        this.axios.get(api.getAllQualityTemplate).then((res) => {
          if (res && res.data && res.data.code === 0) {
            resolve(res.data.datas || []);
            this.qualityTemplateList = res.data.datas || [];
            (res.data.datas || []).forEach(item => {
              if (!this.$common.isEmpty(item.qualityClassificationId)) {
                this.$set(this.qualityTemplateJson, item.qualityClassificationId, item.qualityProjectVOList);
              }
            })
          } else {
            resolve([]);
          }
        }).catch(() => {
          resolve([]);
        })
      })
    }
  }
};
</script>

<style lang="less" scoped>
.quality-inspection-standard{
  position: relative;
  width: 100%;
  .quality-edit-table{
    :deep(.ivu-table-tbody) {
      .ivu-form-item{
        margin-bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>
